module.exports = __webpack_public_path__ + "static/media/bong.fad6a704.svg";